var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"93f47d3cda0ffd5a6d7437f9b5935a70ac4fc4cb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hoyer-xp@harlapp-gmbh"]={id:"93f47d3cda0ffd5a6d7437f9b5935a70ac4fc4cb"};
      